import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'isImage',
  standalone: true
})
export class IsImagePipe implements PipeTransform {
  transform(value: string | undefined): boolean {
    const imageTypes = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.heic', '.heif']

    return imageTypes.some((ext) => value?.toLowerCase()?.endsWith(ext))
  }
}
